var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('polygon',{attrs:{"points":"10,0 60,0 35,45","fill":_vm.skinType?'white':'black'}})}
var staticRenderFns = []

export { render, staticRenderFns }